import type StagingConfig from './Config-staging';

export default {
    api: 'https://app.paytron.com.au/api',
    api_url: 'https://leibis74yj.execute-api.ap-southeast-2.amazonaws.com/prod/api',
    bucketUrl: 'https://paytron-data-prod.s3-ap-southeast-2.amazonaws.com/',
    termConditionUrl: 'https://paytron.com.au/legals',
    paytronHomePage: 'https://www.paytron.com',
    meaWalletCardDataUrl: 'https://mcd.meawallet.com/easylaunch',

    TimerRefreshRate: 15, // seconds
    MinConversionAmount: 5, // GBP
    MaxConversionAmount: 10000000, // GBP
    paytronURL: 'https://app.paytron.com.au',
    datadogEnvironment: 'app.paytron.com.au',
    xeroClientId: 'AACE5C0E2D824B7E96190640D68D6660',
    xeroOAuthScopes:
        'offline_access accounting.transactions accounting.attachments accounting.settings accounting.contacts bankfeeds accounting.reports.read',

    // Payment templates
    templates_url: 'https://paytron-templates-prod.s3.ap-southeast-2.amazonaws.com',

    kyc_private_api: 'https://7mvx3fql40.execute-api.ap-southeast-2.amazonaws.com/prod',
    kyc_public_api: 'https://qlltb9v2fe.execute-api.ap-southeast-2.amazonaws.com/prod',
    payment_api: 'https://mkn9095m98.execute-api.ap-southeast-2.amazonaws.com/prod',
    payments_api: 'https://pk6ei29nbj.execute-api.ap-southeast-2.amazonaws.com/prod',
    payroll_api: 'https://rh0vr2m9pg.execute-api.ap-southeast-2.amazonaws.com/prod',
    prism_api: 'https://prism.api.paytron.com/features',
    transactions_api: 'https://0rglfzar98.execute-api.ap-southeast-2.amazonaws.com/prod',
    users_api: 'https://ob0etey1mk.execute-api.ap-southeast-2.amazonaws.com/prod',
    referrals_api: 'https://zp820x8fma.execute-api.ap-southeast-2.amazonaws.com/prod/referrals',
    notes_api: 'https://drucboq7xb.execute-api.ap-southeast-2.amazonaws.com/prod/notes',
    cards_api: 'https://d7uwohd7t0.execute-api.ap-southeast-2.amazonaws.com/prod',
    cards_api_v2: 'https://kch92ifbyl.execute-api.ap-southeast-2.amazonaws.com/prod',
    keypay_client_id: '64arcg9masr35k9sum54s0soka',
    // Keypays oauth client id and referral code for branding switcher
    keypay_referral_code: 'ba1dc407-4e8d-4252-89ca-d6f75c2c551a',

    // TODO
    fund_by_card_api: 'https://credit-cards.api.paytron.com',
    direct_debits_api: 'https://direct-debits.api.paytron.com',
    // Payments2
    bills_api_v1: 'https://bills.api.paytron.com',
    bulk_payments_api: 'https://bulk-payments.api.paytron.com',
    payments2_api: 'https://payments.api.paytron.com',
    beneficiaries_api: 'https://beneficiaries.api.paytron.com',

    plans_api: 'https://plans.api.paytron.com',
    subscriptions_api: 'https://subscriptions.api.paytron.com',
    invoices_api: 'https://invoices.api.paytron.com',

    custom_categories_api: 'https://custom-categories.api.paytron.com',
    quotes_json_api_v1: 'https://quotes.api.paytron.com',
    groups_json_api_v1: 'https://groups.api.paytron.com',

    frankieone_api: 'https://dkwd1tnpuk.execute-api.ap-southeast-2.amazonaws.com/prod/',
    approvals_api: 'https://6l1w4ivqy1.execute-api.ap-southeast-2.amazonaws.com/prod',
    audits_api: 'https://4p6vman351.execute-api.ap-southeast-2.amazonaws.com/prod',
    notifications_api: 'https://04aih5x5pc.execute-api.ap-southeast-2.amazonaws.com/prod',

    companies_v1_api: 'https://app.paytron.com.au/api/companies/v1',
    users_v1_api: 'https://app.paytron.com.au/api/users/v1',
    user_management_api: 'https://app.paytron.com.au/api/user-management/v1',

    /** Admin APIs */
    companies_admin_v1_api: 'https://companies.admin.api.paytron.com/v1',
    user_management_admin_api: 'https://user-management.admin.api.paytron.com/v1',
    subscriptions_admin_api: 'https://subscriptions.admin.api.paytron.com/v1',

    /** Public keys used by PIN Iframes when creating new cards */
    pinPublishKeyAustralia: 'pk_G4MY1nbeQy8adgsplpuSRQ',
    pinPublishKeyNewZealand: 'pk_6ZH1ImmCfMfJLSjYHf6ezg',

    /** Okta External */
    oktaExternalClientId: 'paytron-prd',
    oktaExternalServerHostUrl: 'https://identity.paytron.com.au',
    oktaExternalSignInRedirectPath: '/oktaextsignin',
    oktaExternalSignOutRedirectPath: '/oktaextsignout',
    oktaExternalManageMfaUrl: 'https://okta-mfa-enrolment.cui.prd.aws.ofx.com',

    /** Okta Mobile External */
    oktaMobileExternalClientId: 'paytron-mobile-prd',

    /** Okta Internal */
    oktaInternalClientId: '0oa1p0uotobflzVnc1d8',
    oktaInternalServerHostUrl: 'https://ofx.okta.com',
    oktaInternalSignInRedirectPath: '/oktaintsignin',
    oktaInternalSignOutRedirectPath: '/oktaintsignout',
} satisfies typeof StagingConfig;
